import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import Print from "./details/Print";
import { useAssetsGetModel } from "../assetsGetModel";

export function ManageAssetsGet() {
    const { selectedRowKeys } = useAssetsGetModel();
    return (
        <>
            <PageHeader />
            <DataBox />
            <Print id={selectedRowKeys[0]} />
        </>
    );
}